import { render, staticRenderFns } from "./PopUpCart.vue?vue&type=template&id=4fb36cec&scoped=true&"
import script from "./PopUpCart.vue?vue&type=script&lang=js&"
export * from "./PopUpCart.vue?vue&type=script&lang=js&"
import style0 from "./PopUpCart.vue?vue&type=style&index=0&id=4fb36cec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb36cec",
  null
  
)

export default component.exports